module.exports = __webpack_public_path__ + "assets/img/25_391_big.088c39fa.jpg";